module.exports = __webpack_public_path__ + "static/media/icon-about.d11c2f16.svg";